import { PlainModal } from '@/components/modals/plain-modal';
import { TextLink } from '@/components/text-link';
import { joinSgcmMsSite } from '@/utils/url/join/public';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const RoadTaxModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerRoadTaxModal}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      Road tax values are calculated based on the engine capacity
      on a per annum basis.
      <br />
      Road tax values can be computed using our
      <TextLink
        className={styles.textLink}
        href={`${joinSgcmMsSite('/resources/road-tax-calculator')}`}
        text=" road tax calculator" />
      .
    </div>
  </PlainModal>
);
